<template>
    <v-row no-gutters class="head_bgActivity card cardbg">
      <div :style="'z-index: 0;font-size: 20px;font-weight: bold;position: relative;height:65px;padding:15px;background-color:' + ($isTargetShop ? '#ffa300' : $bgColor)" fixed dense >
            <a :style="'color:' + (isTargetShop ? '#000' : $CUSTOMMainTextColor)"> <v-icon @click="$router.go(-1)" style="cursor: pointer;">mdi-chevron-left</v-icon>{{ $t("message.activity") }}</a>
            <!-- <div  class="fb-share-button" data-href="https://developers.facebook.com/docs/plugins/" data-layout="button_count" data-size="small">
              <a style="color: white;text-decoration: none;" target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fplugins%2F&amp;src=sdkpreparse" class="fb-xfbml-parse-ignore">กิจกรรม</a>
            </div> -->
      </div>
      <!-- <v-col class="cardbg" :style="'background-color:' + $bgColor3 + ';'"> -->
        <div :style="'color:' + HEXToVBColorLMG(levelById && levelById.color)">
          <v-fade-transition mode="out-in">
            <div style="min-height: 90vh" class="card1">
              <!-- <v-btn @click="share()">share</v-btn> -->
              <!-- <p class="result"></p> -->
              <activity-backup></activity-backup>
              <!-- <all-activity></all-activity> -->
            </div>
          </v-fade-transition>
        </div>
      <!-- </v-col> -->
    </v-row>
</template>
<style scoped>
/* .card1 {
  height: 100%;
  overflow: hidden;
  background-color: --color_headline1 !important;
  border-radius: 0px 0px 0px 0px;
} */
.card {
  height: 100%;
  overflow: hidden;
}
.cardbg {
  background-repeat: no-repeat !important;
  background-size: 90% 110% !important;
  background-attachment: fixed;
  background-position: center;
}
</style>
<script>
import HeaderProfile from '../../HeaderProfile'
import MenuItem from '../../MenuItem'
import AllActivity from './AllActivity'
import ActivityBackup from './ActivityBackup'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ActivityMain',
  metaInfo: {
    // title: 'My Activity',
    meta: [
      { property: `og:title`, content: 'กิจกรรม' },
      { property: 'og:image', content: 'https://storage.googleapis.com/betask-linked/static/upload/Shop/SH261_20221229231505684117.jpeg' }
    ]
  },
  components: {
    'header-profile': HeaderProfile,
    'menu-item': MenuItem,
    'all-activity': AllActivity,
    'activity-backup': ActivityBackup
  },
  data () {
    return {
      levelById: null,
      activity: null,
      member: null,
      profile: [],
      shopId: null,
      shareData: {
        title: 'MDN',
        text: 'Learn web development on MDN!',
        url: `https://liff.line.me/1656906322-JN5MM8Ep/home?shopId=${this.shopId}`
      }
    }
  },
  computed: {
    isTargetShop () {
      return this.$isTargetShop()
    }
  },
  async mounted () {
    if (this.$route.query.shopId) {
      if (typeof this.$session.getAll().shopId === 'undefined') {
        this.$session.remove('shopId')
        this.$session.start()
        this.$session.set('shopId', this.$route.query.shopId)
      }
    }
    this.shopId = this.GET_SHOPID()
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    await this.transactionVisitPage()
    await this.getLevelById()
    window.scrollTo(0, 0)
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapActions('lineStore', ['setProfile']),
    ...mapActions('memberStore', ['getMemberProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapGetters('shopStore', ['GET_SHOPID', 'GET_THEME', 'GET_SHOPINFO']),

    async getLevelById () {
      if (!this.member || !this.member.levelId) {
        return null
      }
      const result = await this.callBeTaskAPI(
        'get',
        `/level/getID?RECORD_STATUS=N&levelId=${this.member.levelId}`
      )

      if (result) {
        this.levelById = result
        return result
      }
    },
    async getActivity () {
      const result = await this.callBeTaskAPI('get', `/activity/line/get`)
      if (Array.isArray(result)) {
        this.activity = result
      }
    },
    async share () {
      // const resultPara = document.querySelector('.result')
      let url = encodeURIComponent(`https://betask-loyalty-web.web.app/home?shopId=${this.shopId}&type=welcome`)
      // let redicrecUrl = encodeURIComponent(`https://betask-loyalty-web.web.app/home?shopId=${this.shopId}`)
      window.location = `https://www.facebook.com/v5.0/dialog/share?app_id=353978626320785&href=${url}`
      // try {
      //   await navigator.share(this.shareData).then((res) => { window.location.reload() })
      //   alert('test2')
      // } catch (err) {
      //   window.location.reload()
      //   resultPara.textContent = `Error: ${err}`
      // }
    },
    goBack () {
      window.history.back()
    },
    async transactionVisitPage () {
      const shopId = (this.member && this.member.shopId) || this.shopId
      const createUser = this.member && this.member.lineUserId

      const result = await this.callBeTaskAPI(
        'post',
        `/TransactionVisitPage/add`, {
          page: 'Activity',
          shopId: shopId,
          CREATE_USER: createUser
        }
      )
      if (result) {
      }
    },
    HEXToVBColorLMG (hex) {
      if (!/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(hex)) {
        return '#000000'
      }

      let rr = parseInt(hex.substring(1, 3), 16)
      let gg = parseInt(hex.substring(3, 5), 16)
      let bb = parseInt(hex.substring(5, 7), 16)

      let brightness = (rr * 0.299) + (gg * 0.587) + (bb * 0.114)

      // console.log('/C/card', brightness)

      if (brightness > 180) {
        return '#000000' // สีเข้ม
      } else {
        return '#FFFFFF' // สีขาว
      }
    }
  }
}
</script>
<style>
div.sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/HomeCUSTOM/Activity/Main.vue